import { FabricDiagramStateHolder } from "../../modules/FabricDiagramStateHolder";

/**
 * @description Event emitter singleton
 */
export const DiagramEventEmitter = (function () {
    const instance = {};
    class DiagramEventEmitter {
        canvas;

        eventName = "FABRIC_DIAGRAM_EVENT";

        diagramStateHolder;

        instanceUuid;

        constructor(diagramInstanceUuid) {
            if (!instance[diagramInstanceUuid]) {
                // setting the singleton instance
                instance[diagramInstanceUuid] = this;
                this.instanceUuid = diagramInstanceUuid;
            }
            return instance[diagramInstanceUuid];
        }

        /**
         * @description registers the reference to the canvas element
         * @param {HTMLElement} canvas - canvas element
         */
        registerCanvasElement(canvas) {
            this.canvas = canvas;
        }

        /**
         * @description Emits event on the canvas
         * @param {String} type - Event type
         * @param {Object} payload -  event payload
         * @param {Boolean} historyOnly - Indicates if the event should only be sent to the history handler class
         * @param {Boolean} prventHistoryRecording - Indicates if the event should avoid be recorded into the history
         */
        emitEvent(type, payload, historyOnly, prventHistoryRecording) {
            const event = new CustomEvent(this.eventName, { detail: { payload, type } });
            if (!this.canvas && !this.instanceUuid) {
                return;
            }
            if (!this.canvas) {
                console.error("Can't dispatch events to a unregistered Canvas element!");
                return;
            }
            if (!historyOnly) {
                this.canvas.dispatchEvent(event);
            }
            if (!this.diagramStateHolder) this.diagramStateHolder = new FabricDiagramStateHolder(this.instanceUuid);
            if (!prventHistoryRecording) {
                this.diagramStateHolder.eventHappened({ type, payload });
            }
        }

        /**
         * @description desotrys the instance
         * @param {String} instaceUuid - diagram instance uuid
         */
        destroy(instaceUuid) {
            instance[instaceUuid] = null;
            delete instance[instaceUuid];
        }
    }
    return DiagramEventEmitter;
}());
